<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('university-discount-management-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator" @click="OpenReport()">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>
            </div>
            <!-- UniversityDiscount -->
            <div class="text-xs-right">
                <v-btn v-can:add :to="{ name: 'add-university-discount-management' }" color="success">
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-university-discount-management') }}
                </v-btn>
                <v-menu v-if="selected.length" bottom left origin="center center" transition="scale-transition" min-width="100">
                    <v-btn icon flat slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteUniversityDiscount" v-can:delete>
                            <v-list-tile-title>Delete</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postUniversityDiscount" v-can:post>
                            <v-list-tile-title>Post</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostUniversityDiscount" v-can:unpost>
                            <v-list-tile-title>Unpost</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Search box -->
        <v-flex xs12>
            <v-card class="pa-2 pt-3 mb-3">
                <v-form @submit.prevent="getUniversityDiscounts">
                    <v-layout wrap>
                        <!--<v-flex md4 sm6 xs12 class="px-2 mb-2">
                            <v-text-field :label="$t('beneficiary-name')"
                                          v-model="filter.beneficiaryName"
                                          v-validate="'max:50'"
                                          :data-vv-as="$t('beneficiary-name')"
                                          :error-messages="errors.collect('beneficiaryName')"
                                          name="beneficiaryName"></v-text-field>
                        </v-flex>-->
                        <v-flex md4 sm6 xs12 class="px-2 mb-2">
                            <v-autocomplete :label="$t('universityTraining')"
                                            v-model="filter.university"
                                            :items="universityList"
                                            name="university"
                                            :item-text="getLabelByLang('name', 'name')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>
                        <v-flex md4 sm6 xs12 class="px-2 mb-2">
                            <v-autocomplete :label="$t('specialization')"
                                            v-model="filter.specialization"
                                            :items="specializationList"
                                            name="specialization"
                                            :item-text="getLabelByLang('name', 'name')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>
                        <v-flex md2 sm6 xs12 px-2>
                            <v-text-field :label="$t('national-number')" v-model="filter.beneficiaryNationalNumJOR"></v-text-field>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="fromDateMenu">
                                <v-text-field :data-vv-as="$t('from-date')"
                                              :error-messages="errors.collect('fromDate')"
                                              :label="$t('from-date-creation')"
                                              clearable
                                              name="fromDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.fromDate"></v-text-field>
                                <v-date-picker :min="'1900-01-01'"
                                               :max="''"
                                               @change="fromDateMenu = false"
                                               ref="picker"
                                               v-model="filter.fromDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="toDateMenu">
                                <v-text-field :data-vv-as="$t('to-date')"
                                              :error-messages="errors.collect('toDate')"
                                              :label="$t('to-date-creation')"
                                              clearable
                                              name="toDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.toDate"></v-text-field>
                                <v-date-picker :min="'1900-01-01'"
                                               @change="toDateMenu = false"
                                               ref="picker"
                                               v-model="filter.toDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governoratesList"
                                            :label="$t('governorate')"
                                            clearable
                                            item-value="code"
                                            name="governorate"
                                            v-model="filter.governorate"></v-autocomplete>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('city')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="citiesList"
                                            :label="$t('city')"
                                            clearable
                                            item-value="code"
                                            name="city"
                                            v-model="filter.city"></v-autocomplete>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('disability-type')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="disabilityNaturesList"
                                            :label="$t('disability-type')"
                                            clearable
                                            item-value="code"
                                            name="typeOfDisability"
                                            v-model="filter.disabilityType"></v-autocomplete>
                        </v-flex>
                        <!--<v-flex md4 sm6 xs12 class="px-2 mb-2">
                            <v-autocomplete :label="$t('educational-level')"
                                            v-model="filter.educationalLevel"
                                            :items="educationalLevelList"
                                            name="educationalLevel"
                                            :item-text="getLabelByLang('name', 'name')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>-->
                        <v-flex xs12>
                            <v-btn color="primary" type="submit" @click="getUniversityDiscounts()">{{ $t('filter') }}</v-btn>
                            <v-btn color="primary" type="reset" @click="resetForm()">{{ $t('reset') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          :loading="isLoading"
                          :headers="headers"
                          :items="universityDiscount"
                          v-model="selected"
                          select-all
                          class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.createdat | date }}</td>
                        <td>{{ props.item.beneficiaryName }}</td>
                        <td>{{ props.item.universityName }}</td>
                        <td>{{ props.item.specialityName }}</td>
                        <td>{{ props.item.semester }}</td>
                        <td>{{ props.item.discount }}</td>
                        <td>
                            <v-btn icon
                                   v-can:edit
                                   :to="{
                  name: 'edit-university-discount-management',
                  params: { beneficiaryInformationId: props.item.beneficiaryInfoId, id: props.item.id }
                }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <!--<td>
        <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
        <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
    </td>-->
                    </tr>
                </template>
            </v-data-table>
            <v-btn color="primary" type="reset" @click="deleteUniversityDiscount()">{{ $t('delete') }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import LookUpService from '@/services/LookUpService';
    import UniversityDiscountManagementService from '@/services/Disabilities/PersonWithDisabilities/UniversityDiscountManagement/UniversityDiscountManagementService';
    import SettingOrgService from "@/services/AdminSystem/OrganizationStructure/SettingOrgService";

    export default {
        name: 'university-discount-management',
        data() {
            return {
                universityDiscount: [],
                selected: [],
                filter: {
                    keyword: '',
                    id: 0,
                    university: '',
                    specialization: '',
                    year: 0,
                    semester: 0,
                    educationalLevel: '',
                    disabilityCategories: '',
                    beneficiaryName: '',
                    discount: 0,
                    isActive: true,
                    beneficiaryNationalNumJOR: '',
                    fromDate: null,
                    toDate: null,
                    governorate: '',
                    disabilityType: '',
                    city: '',
                },
                isLoading: false,
                universityList: [],
                specializationList: [],
                educationalLevelList: [],
                citiesList: [],
                governoratesList: [],
                disabilityNaturesList: [],
                fromDateMenu: false,
                toDateMenu: false,
            };
        },
        async created() {
            this.$store.dispatch('showLoading');
            await this.getUniversities();
            await this.getSpecializations();
            await this.getEducationalLevels();
            this.$store.dispatch('hideLoading');
            await this.getUniversityDiscounts();
            await this.getGovernorates();
            await this.getCities();
            await this.getDisabilityNatures();
        },
        methods: {
            async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getCities() {
                this.citiesList = (await LookUpService.getLookup(100)).data;
            },
            async getUniversityDiscounts() {
                this.universityDiscount = [];
                this.isLoading = true;
                const universityDiscount = (await UniversityDiscountManagementService.getUniversityDiscountManagements(this.filter)).data;
                this.universityDiscount = universityDiscount;
                this.isLoading = false;
            },
            deleteUniversityDiscount() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete users */
                    this.$store.dispatch('showLoading');
                    const result = await UniversityDiscountManagementService.deleteUniversityDiscountManagement(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        //var firstIndexOf = result.data.message.indexOf('(') + 1;
                        //var lastIndexOf = result.data.message.indexOf(')');
                        //var gropsNames = result.data.message.substring(firstIndexOf, lastIndexOf);
                        //var arrayNames = gropsNames.split(',');
                        //var displayString = `${this.$t('delete')} ${arrayNames.length} ${this.$t('group_s')}`;
                        //arrayNames.forEach((group, index) => {
                        //    displayString += `\n ${index + 1} - ${group}`;
                        //});
                        this.$store.dispatch('showMessage', {
                            text:result.data.message,
                            multiLine: true
                        });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    await this.getUniversityDiscounts();
                });
            },
            async postUniversityDiscount() {
                let postUniversityDiscounts = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postUniversityDiscounts.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await UniversityDiscountManagementService.postUniversityDiscountManagement(postUniversityDiscounts);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getUniversityDiscounts();
            },
            async unpostUniversityDiscount() {
                let postUniversityDiscounts = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postUniversityDiscounts.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await UniversityDiscountManagementService.postUniversityDiscountManagement(postUniversityDiscounts);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getUniversityDiscounts();
            },
            async getUniversities() {
                this.universityList = (await LookUpService.getLookup(44)).data;
            },
            async getSpecializations() {
                this.specializationList = (await LookUpService.getLookup(47)).data;
            },
            async getEducationalLevels() {
                this.educationalLevelList = (await LookUpService.getLookup(54)).data;
            },
            resetForm() {
                this.filter.beneficiaryName = '';
                this.filter.university = '';
                this.filter.specialization = '';
                this.filter.educationalLevel = '';
                this.filter.fromDate = null;
                this.filter.toDate = null;
                this.filter.governorate = '';
                this.filter.city = '';
                this.filter.procedureType = '';
                this.filter.disabilityType = '';
                this.getUniversityDiscounts();
            },
            async    OpenReport() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/Universitydiscount.aspx?disabilityType=' + this.filter.disabilityType, '_blank');
                }
            },
        },
        computed: {
            selectedIds() {
                return this.selected.map(universityDiscount => ({
                    id: universityDiscount.id
                }));
            },

            headers() {
                return [
                    { text: this.$t('request-date'), value: 'createdat', sortable: false },
                    {
                        text: this.$t('beneficiary-name'),
                        value: 'beneficiaryName',
                        sortable: false
                    },
                    {
                        text: this.$t('universityTraining'),
                        value: 'universityName',
                        sortable: false
                    },
                    {
                        text: this.$t('specialization'),
                        value: 'specialityName',
                        sortable: false
                    },
                    {
                        text: this.$t('semester'),
                        value: 'semester',
                        sortable: false
                    },
                    {
                        text: this.$t('discount'),
                        value: 'discount',
                        sortable: false
                    },
                    { text: this.$t('edit'), value: '', sortable: false },
                    //{ text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            }
        }
    };
</script> 